import React from 'react';
import 'twin.macro';
import { MenuItem } from 'components/NavLink/MenuItem';

interface Props {
  items: React.ComponentProps<typeof MenuItem>['item'][];
  goTo: (v: string) => void;
  currentRoute: string;
}

export function SubNavigationSidebar(props: Props) {
  const { items } = props;

  return (
    <aside tw="space-y-2 lg:col-span-3">
      {items.map((item, i) => {
        const isCurrent = location.pathname.startsWith(item.route);
        return (
          <React.Fragment key={item.route}>
            {i !== 0 && <hr tw="lg:hidden" />}
            <MenuItem
              item={{
                title: item.title,
                route: item.route,
                icon: item.icon,
                active: isCurrent,
              }}
            />
          </React.Fragment>
        );
      })}
    </aside>
  );
}
